import {
  fork,
} from 'redux-saga/effects';

import updatePopperSaga from './updatePopperSaga';

export default function* root() {
  yield fork(updatePopperSaga);
}
